import CandidateProfileDocumentsEmpty from './CandidateProfileDocumentsEmpty.component';

export default CandidateProfileDocumentsEmpty;